import { getTitleClampClass } from '@/app/_components/shared/event-card/event-card.variants';
import type { CardVariant } from '@/app/_components/shared/event-card/event-card.variants';
import { cn } from '@/app/_lib/utils';

export interface CardTitleBlockProps {
  title: string;
  maxLines: 1 | 2 | 5;
  variant: CardVariant;
  className?: string;
}

export function CardTitleBlock({
  title,
  maxLines,
  variant,
  className,
}: CardTitleBlockProps) {
  return (
    <h3
      title={title}
      className={cn(
        'my-2 text-lg/normal  font-medium text-card-foreground',
        getTitleClampClass(maxLines, variant),
        className
      )}
    >
      {title}
    </h3>
  );
}
